module.exports = require('angular').module('angular-popups', []);


//////////////////
// WEBPACK FOOTER
// ./src/ng-module.js
// module id = 6
// module chunks = 0